export async function fetchJsonWithErrorHandling(options) {
	const response = await fetchWithErrorHandling(options)
	if (response.ok) {
		try {
			return await response.json()
		}
		catch (error) {
			throw new FetchError({
				reason: "MALFORMED BODY",
				status: 200
			})
		}
	}
	else {
		throw await errorFromJsonResponse(response)
	}

}

export async function fetchBlobWithErrorHandling(options) {
	const response = await fetchWithErrorHandling(options)
	if (response.ok) {
		return await response.blob()
	}
	else {
		throw new FetchError({
			reason: "STATUS NOT OK",
			status: response.status
		})
	}
}

export async function fetchWithErrorHandling({ path, query = {}, ...options }) {
	const url = path + "?" + objectToQueryString(query)
	try {
		return await fetch(url, options)
	}
	catch (error) {
		throw new FetchError({
			reason: "NO INTERNET"
		})
	}
}

async function errorFromJsonResponse(response) {
	try {
		return new FetchError({
			reason: "STATUS NOT OK",
			body: await response.json(),
			status: response.status
		})	
	}
	catch (error) {
		return new FetchError({
			reason: "STATUS NOT OK",
			status: response.status
		})
	}
}

function objectToQueryString(obj) {
    return Object.entries(obj)
       .filter(([key, value]) => value != null)
       .map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value))
       .join('&')
}

class FetchError extends Error {

	constructor(data) {
		super("FetchError: " + data.reason)
		this.data = data
		this.fetchError = true
	}

}



// WEBPACK FOOTER //
// ./src/utils/fetch.js